<script setup lang="ts">
import type { SegmentedOption } from '@/ui/UiSegmentedControl.vue';
import type { TemplateStatus } from '@beeboard/common';

const props = defineProps<{
  modelValue: TemplateStatus | undefined;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'select', status: TemplateStatus): void;
}>();

// Ordered least to most available: retired, being worked on, usable by everyone.
// The variants are the badge colours, so the control doubles as the status badge.
const options = computed<SegmentedOption<TemplateStatus>[]>(() => [
  {
    value: 'inactive',
    label: $t('template.statusInactive'),
    variant: 'neutral',
  },
  { value: 'draft', label: $t('template.statusDraft'), variant: 'warning' },
  {
    value: 'released',
    label: $t('template.statusReleased'),
    variant: 'success',
  },
]);
</script>

<template>
  <UiSegmentedControl
    block
    :options="options"
    :model-value="props.modelValue"
    :disabled="props.disabled"
    :aria-label="$t('template.status')"
    @select="emit('select', $event)"
  />
</template>
